import { render, staticRenderFns } from "./RegisterPatientDialog.vue?vue&type=template&id=ae98e3ba&scoped=true&lang=pug&"
import script from "./RegisterPatientDialog.vue?vue&type=script&lang=js&"
export * from "./RegisterPatientDialog.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPatientDialog.vue?vue&type=style&index=0&id=ae98e3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae98e3ba",
  null
  
)

/* custom blocks */
import block0 from "./RegisterPatientDialog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VProgressCircular,VSpacer,VWindow,VWindowItem})
